import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filterUndefined } from 'src/app/lego-utils';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { MouldPerformanceData } from 'src/app/models/domain/mould-performance-data';
import { MouldingProcessDataService } from 'src/app/services/moulding-process-data.service';
import { EquipmentLookupService } from 'src/app/state/equipment/equipment-lookup.service';

@Injectable({ providedIn: 'root' })
export class MouldCardService {
  public constructor(
    private readonly equipmentLookup: EquipmentLookupService,
    private readonly mouldingProcessDataService: MouldingProcessDataService
  ) {}

  public loadByActiveEquipment(): Observable<MouldPerformanceData | undefined> {
    return this.equipmentLookup.selectedEquipmentId$.pipe(
      filterUndefined(),
      switchMap((equipmentNumber) =>
        this.mouldingProcessDataService.getMouldCardByEquipmentNumber(equipmentNumber).pipe(
          catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 404) {
              return of(undefined);
            }

            throw error;
          })
        )
      )
    );
  }
}
